<div id="confettiDiv" #confettiDiv>  
    <div class="image-container">  
      <div class="image"></div>  
    </div>  
  </div>  
  